module.exports = __webpack_public_path__ + "42e75496f850fe35df772c92447601b6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/mini-snowman.png
// module id = 2561
// module chunks = 0